import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

var Barcode = require('react-barcode');
const ViewRawMaterial = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [barcodeSuppliers, setBarcodeSuppliers] = useState([]);
  const [barcodeProducts, setBarcodeProducts] = useState([]);
  const [palletesationsall, setPalletesationsall] = useState([]);
  const [permission, setPermission] = useState({});

  

  useEffect(() => {
    setPermission(FindModuleById(42));
    console.log(permission);


    axios
      .get(`/raw-materials/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.raw);
          setPalletesationsall(response.data.data.raw.palletesations)
          console.log(response.data.data.raw);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          setBarcodeProducts(products);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          setBarcodeSuppliers(suppliers);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, [id]);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const handleDownloadRawMaterial = async () => {
    if (!value.lot_number) {
      console.error('Lot number is not available yet');
      return;
    }

    $("#loader-image2").removeClass('loader-hide');
    $("#loader-image2").addClass('loader-show');

    axios.get(`/raw-materials/pdf-raw-material/${id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = value.lot_number + '.pdf';
        link.download = file_name;
        link.click();

        $("#loader-image2").addClass('loader-hide');
        $("#loader-image2").removeClass('loader-show');
      })
      .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image2").addClass('loader-hide');
        $("#loader-image2").removeClass('loader-show');
      });
  };
  function cleanCode(str) {
    return str.replace(/(-MB|-BFY|-DF)$/, "");
  }
  const handleDownload = (barcode_data) => {
    const supplierId = value.supplier;
    const product_details = barcodeProducts.find(user => user.id === barcode_data.product);
    const supplier_details = barcodeSuppliers.find(user => user.id === supplierId);
    const supplier_name = (supplier_details && supplier_details.name) ? supplier_details.name : "";

    let get_contents = '';
    get_contents += '<div id="div-print">';

    get_contents += '<table class="table" style="width:100%">';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Lot Number#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + cleanCode(value.lot_number) + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Date And Time#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + value.date_time + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Service.P</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + supplier_name + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Product</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + product_details.name + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Gross Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.gross_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Net Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.net_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Boxes#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.number_of_boxes + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Barcode#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.barcode + '</td></tr>';
    get_contents += '</table><br/>';

    // Dynamically create temporary div to render BarcodeComponent
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);

    const root = createRoot(tempDiv);
    root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

    // Delay to allow React to render before reading innerHTML
    setTimeout(() => {
      const barcodeHtml = tempDiv.innerHTML;
      get_contents += barcodeHtml;
      get_contents += '</div>';

      const width = 300;
      const height = 300;
      const widthInPixels = width * 3.779527559;
      const heightInPixels = height * 3.779527559;
      const left = (window.screen.width - widthInPixels) / 2;
      const top = (window.screen.height - heightInPixels) / 2;
      const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

      const printWindow = window.open('', '', windowFeatures);
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
      printWindow.document.write(get_contents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // Delay print slightly to ensure DOM is ready
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);

      // Clean up temp div
      document.body.removeChild(tempDiv);
    }, 500);
  };

  const BarcodeComponent = ({ barcodeData }) => {
    return (
      <div>
        <Barcode value={barcodeData} format="CODE128" width={7} height={120} displayValue={false} />
      </div>
    );
  };
  BarcodeComponent.propTypes = {
    barcodeData: PropTypes.string.isRequired, // Assuming barcodeData is a string
  };



 const result_pallet = (palletesationsall || []).reduce((acc, item) => {
  const type = item.type;
  const weight = parseFloat(item.net_weight) || 0;
  const gross_weight = parseFloat(item.gross_weight) || 0;
  const number_of_boxes = parseFloat(item.number_of_boxes) || 0; // ✅ define boxes here

  // Initialize if not exists
  if (!acc[type]) acc[type] = { weight: 0, grossweight: 0, boxes: 0 };

  // Sum weight, gross weight, and boxes
  acc[type].weight += weight;
  acc[type].grossweight += gross_weight;
  acc[type].boxes += number_of_boxes; // ✅ use it here

  return acc;
}, {});
const formatted_result_pallet = {
  "Grade_A": {
    weight: result_pallet[1]?.weight || 0,
    grossweight: result_pallet[1]?.grossweight || 0,
    boxes: result_pallet[1]?.boxes || 0,
  },
  "Grade_B": {
    weight: result_pallet[2]?.weight || 0,
    grossweight: result_pallet[2]?.grossweight || 0,
    boxes: result_pallet[2]?.boxes || 0,
  },
  "Total": {
    weight: (result_pallet[1]?.weight || 0) + (result_pallet[2]?.weight || 0),
    grossweight: (result_pallet[1]?.grossweight || 0) + (result_pallet[2]?.grossweight || 0),
    boxes: (result_pallet[1]?.boxes || 0) + (result_pallet[2]?.boxes || 0),
  },
};

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-materials">Raw Materials</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Raw Material
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {permission && permission.list === 1 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">View Raw Material Info</h4>
                      <div style={{ float: "right" }}>
                        <button onClick={() => handleDownloadRawMaterial()} className="btn btn-primary me-1"  > Download Raw Material <i className="fa fa-download" /> <img id="loader-image2" className="loader-image loader-hide" src={loader_image} />  </button>
                      </div>
                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">Lot Number</th>
                          <td className="p-3">
                            {value.lot_number}
                            {/* <Barcode value={value.lot_number} />, */}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Date & Time</th>
                          <td className="p-3">{value.date_time}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Shift Date</th>
                          <td className="p-3">{value.shift_date}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Supplier Name</th>
                          <td className="p-3">
                            {value.supplier_name?.name}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Plate Number</th>
                          <td className="p-3">{value.plate_number}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Total Net Weight</th>
                          <td className="p-3">{typeof value.total_net_weight_count === 'number' ? value.total_net_weight_count.toFixed(2) : '0'} (KG)


                          </td>
                        </tr>
                        {/* <tr>
                          <th className="p-3">BL Net Weight</th>
                          <td className="p-3">{value.id > 656 ? (value.grade_a_bl_weight + value.grade_b_bl_weight)  : value.net_weight} (KG)</td>
                        </tr> */}
                        <tr>
                          <th className="p-3">BL Net Weight</th>
                          <td className="p-3">
                            {(
                              value.id > 656 || value.id === 630 || value.id == 604 || value.id == 643 || value.id == 440  || value.id == 644 || value.id == 652 
                                ? (value.grade_a_bl_weight + value.grade_b_bl_weight)
                                : value.net_weight
                            )} (KG)
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Farm Name</th>
                          <td className="p-3">
                            {value.farmer_detail ? value.farmer_detail.name : ""}
                          </td>
                        </tr>


                        <tr>
                          <th className="p-3">Driver Name</th>
                          <td className="p-3">{value.driver_name}</td>
                        </tr>


                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.location ? value.location_name.title : ""}
                          </td>
                        </tr>


                        <tr>
                          <th className="p-3">Date Time</th>
                          <td className="p-3">{value.date_time}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Note</th>
                          <td className="p-3">{value.note}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Comment</th>
                          <td className="p-3">{value.comments}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {permission && permission.list === 1 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Palletesation Details</h5>

                      <table className="table table-bordered  text-center">
                        <thead>
                          <tr>
                            <th className="">Barcode</th>
                            <th className=" text-center">Product</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Number of Boxes</th>
                            <th className="text-center">Gross Weight (KG)</th>
                            <th className="text-center">Boxes weight (KG)</th>
                            <th className="text-center">pallet weight (KG)</th>
                            <th className="text-center">Net Weight (KG)</th>
                            <th className=" pull-right">Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {palletesationsall &&
                            palletesationsall.map((item, indx) => (
                              <tr key={item.barcode || indx}>
                                <td className="">{item.barcode}</td>
                                <td className="">{item.productname}</td>
                                <td className="">{item.type_name}</td>
                                <td className="text-center">{item.number_of_boxes}</td>
                                <td className="text-center">{item.gross_weight}</td>
                                <td className="text-center">{item.boxes_weight} </td>
                                <td className="text-center">{item.pallet_weight} </td>
                                <td className="text-center">{item.net_weight} </td>
                                <td>
                                  <div style={{ float: "right" }}>
                                    <button onClick={() => handleDownload(item)} className="btn btn-primary me-1"  > Print Label <i className="fa fa-print" /> <img id={`item-${item.barcode}`} className="loader-image loader-hide" src={loader_image} />  </button>
                                  </div>
                                </td>
                              </tr>
                            ))}

                            
                                        {palletesationsall.length > 0 && (
                                          <>
                                            <tr style={{ borderTop: 'solid' }}>
                                              
                                                <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold', textAlign:'left' }}>
                                                <div>
                                                  <div>Total Number Of Boxes</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.boxes)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.boxes)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.boxes)}
                                                  </p>
                                                </div>
                                              </td>
                                               <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold', textAlign:'left'  }}>
                                                <div>
                                                  <div>Total Gross Weight</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.grossweight)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.grossweight)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.grossweight)}
                                                  </p>
                                                </div>
                                              </td>
                                             
                                              <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold', textAlign:'left'  }}>
                                                <div>
                                                  <div>Total Net Weight</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.weight).toFixed(2)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.weight).toFixed(2)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.weight).toFixed(2)}
                                                  </p>
                                                </div>
                                              </td>


                                            </tr>


                                          </>
                                        )}


                        </tbody>

                      </table>
                    </div>
                  </div>


                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">BL Weight</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Type</th>
                          <th>Gross Weight</th>
                          <th>Net Weight</th>
                        </tr>
                      </thead>


                      {value.bl_weights &&
                        value.bl_weights.map((item, indx) => (
                          <tr key={item.calibre || indx}>
                            <td className="p-3">{item.product_name}</td>
                            <td className="p-3">{item.type_name} </td>
                            <td className="p-3">{item.gross_weight.toFixed(2)} KG</td>
                            <td className="p-3">{item.net_weight.toFixed(2)} KG</td>

                          </tr>
                        ))}

                    </table>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Quality Check</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sample Number</th>
                          <th>Sample Size</th>
                          <th>Unripe Fruits</th>
                          <th>Ripe Fruits</th>
                          <th>Deformed Fruits</th>
                          <th>Decision</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>


                      {value.checklist &&
                        value.checklist.map((item, indx) => (
                          <tr key={item.calibre || indx}>
                            <td className="p-3">{item.simple_number}</td>
                            <td className="p-3">{item.simple_size} (G)</td>
                            <td className="p-3">{item.unripe_fruits.toFixed(2)} %</td>
                            <td className="p-3">{item.ripe_fruits.toFixed(2)} %</td>
                            <td className="p-3">{item.deformed_fruits.toFixed(2)} %</td>
                            <td className="p-3">{item.decision}</td>
                            <td className="p-3">{item.remarks}</td>
                          </tr>
                        ))}
                      <tr>
                        <td className="p-3" style={{ fontWeight: 'bold' }}>Total</td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}>{value.simple_size_sum} (G)</td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}>{value.unripe_fruits_percentage} %</td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}>{value.ripe_fruits_percentage} %</td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}>{value.deformed_fruits_percentage} %</td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}></td>
                        <td className="p-3" style={{ fontWeight: 'bold' }}></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </>
  );
};
export default ViewRawMaterial;
